/* eslint-disable no-bitwise */
/* eslint-disable no-unused-consts */
/* eslint-disable no-useless-escape */

const heroEventBackground = () => {
  let pictures = document.querySelectorAll('.js-hero-event-picture');
  if (pictures.length) {
    let i = 1;
    let len = pictures.length;
    let oldIndex = 0;
    let bgLoop = () => {
      if (!pictures[i].classList.contains('is-active')) {
        pictures[i].classList.add('is-active');
      }
      setTimeout(() => {
        pictures[oldIndex].classList.remove('is-active');
        oldIndex = i;
        i++;
        if (i === len) {
          i = 0;
        }
        bgLoop();
      }, 6000);
    };

    bgLoop();
  }
};

export default heroEventBackground;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/eco-chisel/src/scripts/modules/heroEventBackground.js